<template>
  <div
    style="text-align: right;"
  >
    <el-dropdown
      ref="dropDown"
      size="small"
      @command="handleAction"
    >
      <el-button
        size="mini"
        class="el-dropdown-link"
        @click.stop="toggleDropDown"
      >
        <i :class="!buttonLoader ? 'el-icon-more' : 'el-icon-loading'" />
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-can="'representativeorder.update'"
          :command="viewStockMovement"
          :disabled="buttonLoader"
        >
          <i class="el-icon-view" /> Megtekintés
        </el-dropdown-item>
        <el-dropdown-item
          v-if="stockMovement.status === 'recorded'"
          v-can="'representativeorder.update'"
          :command="updateStockMovement"
          :disabled="buttonLoader"
        >
          <i class="el-icon-edit" /> Módosítás
        </el-dropdown-item>
        <el-dropdown-item
          v-if="stockMovement.status === 'recorded'"
          v-can="'representativeorder.update'"
          :command="finalizeStockMovement"
          :disabled="buttonLoader"
        >
          <i class="el-icon-check" /> Lezárás
        </el-dropdown-item>
        <el-dropdown-item
          v-if="stockMovement.status === 'recorded'"
          v-can="'representativeorder.update'"
          :command="deleteStockMovement"
          :disabled="buttonLoader"
        >
          <i class="el-icon-delete" /> Törlés
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
  export default {
    props: ['stockMovement'],
    data() {
      return {
        buttonLoader: false,
      };
    },

    methods: {
      async viewStockMovement() {
        this.$router.push('/processes/stock-movements/view/' + this.stockMovement.id);
      },
      async updateStockMovement() {
        this.$router.push('/processes/stock-movements/update/' + this.stockMovement.id);
      },
      async finalizeStockMovement() {
        this.$confirm('Biztosan szeretné az áthelyezést lezárni? Amennyiben igen, úgy a kiválasztott termékek a megadott raktárak között átmozgatásra kerülnek', {
          confirmButtonText: 'Igen',
          type: 'warning',
        }).then(async () => {
          await this.$store.dispatch('stockMovement/finalize', this.stockMovement.id);
          await this.$store.dispatch('stockMovement/fetchAllWithPagination');
        })
        .catch((e) => {
          console.error(e)
        });
      },
      async deleteStockMovement() {
        this.$confirm('Biztosan szeretné törölni az áthelyezést?', {
          confirmButtonText: 'Igen',
          type: 'warning',
        }).then(async () => {
          await this.$store.dispatch('stockMovement/delete', this.stockMovement.id);
          await this.$store.dispatch('stockMovement/fetchAllWithPagination');
        })
        .catch((e) => {
          console.error(e)
        });
      },
      handleAction(action) {
        action();
      },
      toggleDropDown() {
        this.$refs['dropDown'].visible = !this.$refs['dropDown'].visible;
      },
    }
  };
</script>
